import { useItem } from '@/composables/item'
import { unitService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { useAlertStore } from '../system'

export const useUnitStore = defineStore('unit', () => {
	const { items, show, getItem } = useItem(unitService, 'units', 'Unit')

	function loadTenants(id: number) {
		return unitService.tenantsGet(id).then(
			({ data }) => data,
			(error) => {
				useAlertStore().errorAlert(error)
			}
		)
	}
	function loadOwner({ id }) {
		return unitService.ownerGet(id).then(
			({ data }) => data,
			(error) => {
				useAlertStore().errorAlert(error)
			}
		)
	}

	return {
		items,
		show,
		getItem,
		loadTenants,
		loadOwner,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useUnitStore, import.meta.hot))
}
